<h2 mat-dialog-title>Forward to…</h2>
<mat-dialog-content>
  <p class="what"><mat-icon>forward</mat-icon><span>{{ data.preview }}</span></p>
  <label class="search">
    <mat-icon>search</mat-icon>
    <input [(ngModel)]="query" placeholder="Search conversations" aria-label="Search conversations" cdkFocusInitial />
  </label>
  <div class="list" role="listbox" aria-multiselectable="true" aria-label="Conversations">
    <button type="button" class="target" *ngFor="let c of rows; trackBy: trackById" (click)="toggle(c)"
      role="option" [attr.aria-selected]="isPicked(c)" [class.picked]="isPicked(c)" [disabled]="!isPicked(c) && picked.length >= max">
      <span class="face" *ngIf="avatar(c) as a" [style.--hue]="a.hue">
        <img *ngIf="photo(c) as src; else drawn" [src]="src" alt="" loading="lazy" />
        <ng-template #drawn>
          <mat-icon *ngIf="a.icon">{{ a.icon }}</mat-icon>
          <span *ngIf="a.initials">{{ a.initials }}</span>
        </ng-template>
      </span>
      <span class="name">{{ title(c) }}</span>
      <span class="tag" *ngIf="tag(c) as t" [attr.data-tone]="tone(c)">{{ t }}</span>
      <mat-icon class="tick">{{ isPicked(c) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </button>
    <p class="empty" *ngIf="!targets.length">No conversation matches.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <span class="count" *ngIf="picked.length">{{ picked.length }} selected</span>
  <button mat-button type="button" (click)="ref.close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" class="send" [disabled]="!picked.length" (click)="send()">
    <mat-icon>send</mat-icon>Forward
  </button>
</mat-dialog-actions>
